import { schema } from "normalizr";

const bankSchema = new schema.Entity("bank", {}, { idAttribute: "id" });

export { bankSchema };
